import * as React from 'react';
import MIconButton, {
  type IconButtonProps as MIconButtonProps,
} from '@mui/material/IconButton';
import { Tooltip } from '@mui/material';

export type IconButtonProps = MIconButtonProps & {
  icon: React.ReactNode;
};

export const IconButton: React.FunctionComponent<IconButtonProps> = (
  props: IconButtonProps,
) => {
  const { title, icon, disabled, ...other } = props;
  return (
    <Tooltip title={disabled ? '' : title}>
      <MIconButton disabled={disabled} {...other}>
        {icon}
      </MIconButton>
    </Tooltip>
  );
};
